import { Controller } from "@hotwired/stimulus"
import JustValidate from "just-validate"
import { applyPendingAuthContinuation } from "./support/auth_continuation"

export default class extends Controller {
    connect() {
        const prefix = `#${this.element.id}`
        const selector = (name) => `${prefix} [name="account[${name}]"]`
        const passwordSelector = selector("password")
        const countryError = this.element.querySelector("[data-signup-country-error]")

        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: true,
            lockForm: true,
            focusInvalidField: true,
            errorFieldCssClass: "is-invalid"
        })

        this.validator
            .addField(selector("username"), [
                { rule: "required", errorMessage: "Email address is required" },
                { rule: "email", errorMessage: "Please enter a valid email address" }
            ])
            .addField(selector("first_name"), [
                { rule: "required", errorMessage: "First name is required" }
            ])
            .addField(selector("last_name"), [
                { rule: "required", errorMessage: "Last name is required" }
            ])
            .addField(
                selector("country"),
                [{ rule: "required", errorMessage: "Country is required" }],
                countryError ? { errorsContainer: countryError } : undefined
            )
            .addField(passwordSelector, [
                { rule: "required", errorMessage: "Password is required" },
                { rule: "minLength", value: 6, errorMessage: "Password must be at least 6 characters" },
                { rule: "maxLength", value: 128, errorMessage: "Password must be no more than 128 characters" }
            ])
            .addField(selector("password_confirmation"), [
                { rule: "required", errorMessage: "Password confirmation is required" },
                {
                    validator: (value, fields) => value === fields[passwordSelector]?.elem?.value,
                    errorMessage: "Passwords must match"
                }
            ])
            .onSuccess((event) => {
                window.echoageSetupDiagnostics?.report?.('signup_submit')
                applyPendingAuthContinuation(event.target)
                event.target.submit()
            })
            .onFail(() => window.echoageSetupDiagnostics?.report?.('signup_validation_blocked', 'validation'))
    }

    disconnect() {
        this.validator?.destroy?.()
    }
}
